<script setup>
const CONTACT_FIELDS = [
  { name: 'name', description: 'Nome do contato' },
  { name: 'phone_number', description: 'Telefone do contato' },
  { name: 'email', description: 'Email do contato' },
  { name: 'id', description: 'ID do contato' },
];

const CONVERSATION_FIELDS = [
  { name: 'conversation.display_id', description: 'ID visível da conversa' },
  { name: 'conversation.id', description: 'ID interno da conversa' },
  { name: 'conversation.status', description: 'Status da conversa' },
];

const emit = defineEmits(['pick']);

const pickContact = f => emit('pick', { token: `{{contact.${f.name}}}`, field: f });
const pickConversation = f => emit('pick', { token: `{{${f.name}}}`, field: f });
</script>

<template>
  <div class="text-xs">
    <div class="text-[10px] uppercase tracking-wide text-slate-400 dark:text-slate-500 mb-1 px-1">
      {{ $t('OMNI.SLOTS.API_AUTOMATIONS.CONTACT', 'Contato') }}
    </div>
    <ul class="space-y-0.5 mb-3">
      <li
        v-for="f in CONTACT_FIELDS"
        :key="f.name"
      >
        <button
          type="button"
          class="w-full flex items-center gap-2 px-2 py-1 rounded text-left hover:bg-woot-50 dark:hover:bg-slate-700 group"
          @click="pickContact(f)"
        >
          <span class="i-lucide-user w-3 h-3 text-slate-400" />
          <span class="text-blue-600 dark:text-blue-400 font-mono font-semibold">contact.{{ f.name }}</span>
          <span class="truncate text-slate-500 dark:text-slate-400 text-[11px]">{{ f.description }}</span>
          <span class="ml-auto text-[10px] opacity-0 group-hover:opacity-100 text-woot-600 dark:text-woot-400">
            {{ $t('OMNI.SLOTS.API_AUTOMATIONS.INSERT', 'Inserir') }}
          </span>
        </button>
      </li>
    </ul>

    <div class="text-[10px] uppercase tracking-wide text-slate-400 dark:text-slate-500 mb-1 px-1">
      {{ $t('OMNI.SLOTS.API_AUTOMATIONS.CONVERSATION', 'Conversa') }}
    </div>
    <ul class="space-y-0.5">
      <li
        v-for="f in CONVERSATION_FIELDS"
        :key="f.name"
      >
        <button
          type="button"
          class="w-full flex items-center gap-2 px-2 py-1 rounded text-left hover:bg-woot-50 dark:hover:bg-slate-700 group"
          @click="pickConversation(f)"
        >
          <span class="i-lucide-message-circle w-3 h-3 text-slate-400" />
          <span class="text-blue-600 dark:text-blue-400 font-mono font-semibold">{{ f.name }}</span>
          <span class="truncate text-slate-500 dark:text-slate-400 text-[11px]">{{ f.description }}</span>
          <span class="ml-auto text-[10px] opacity-0 group-hover:opacity-100 text-woot-600 dark:text-woot-400">
            {{ $t('OMNI.SLOTS.API_AUTOMATIONS.INSERT', 'Inserir') }}
          </span>
        </button>
      </li>
    </ul>
  </div>
</template>
